import React from "react";
import { Settings2 } from "lucide-react"; // Lucide Cog icon
import TranslationModal from "./layer-item-translation-dialog";

const LayerItemTranslations = ({
  layerId,
  layerName,
  onLayerNameChange,
  sidebarWidth,
}: any) => {
  const [open, setOpen] = React.useState(false);

  const [translations, setTranslations] = React.useState(layerName || {});

  const handleSave = (newValues: Record<string, string>) => {
    setTranslations(newValues);
    onLayerNameChange(layerId, newValues);
  };

  return (
    <div
      className="flex items-center gap-2 justify-between"
      style={{
        maxWidth: `${
          sidebarWidth < 470 ? sidebarWidth / 2.6 : sidebarWidth / 1.5
        }px`,
      }}
    >
      <span
        title={Object.entries(translations)
          .map(([lang, name]) => `${lang.toUpperCase()}: ${name}`)
          .join(", ")}
        className="text-sm font-medium w-full truncate whitespace-nowrap overflow-hidden"
      >
        {translations.en}
      </span>

      <button
        className="text-gray-400 hover:text-white"
        onClick={() => setOpen(true)}
      >
        <Settings2 className="w-4 h-4" />
      </button>

      <TranslationModal
        open={open}
        onClose={setOpen}
        initialValues={translations}
        onSave={handleSave}
        title={`Edit Layer Name Translations for #${layerId.slice(-4)}`}
      />
    </div>
  );
};

export default LayerItemTranslations;
